<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtu.be/Pt6IfoIO5gw">
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('feature-summary.png')" alt="ハルイロセカイ3の基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('contents_01_01.png')" alt="ハルセカ史上透明感MAX">
                <img class="img-02" :src="buildImgUrl('contents_01_02.png')" alt="透明感がパワーアップした“ハルセカ史上透明感MAX”な写りが新搭載！">
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <img class="img-01" :src="buildImgUrl('contents_02_01.png')" alt="新しい“ハルセカ史上透明感MAX”な写りと今も人気の“いまっぽ”が選べる！">
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <div class="cont-03-bk">
                    <img class="img-01" :src="buildImgUrl('contents_03_01.png')" alt="ハルセカパーツ選択 過去のハルセカシリーズのパーツバランスが選べるようになったよ！">
                    <img class="img-02" :src="buildImgUrl('contents_03_02.gif')" alt="ハルセカパーツ 画面イメージ">
                    <img class="img-02" :src="buildImgUrl('contents_03_03.png')" alt="さらに！透明感メイク 新しくなったメイクパレットで楽しんでね♡">
                </div>
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <img class="img-01" :src="buildImgUrl('contents_04_01.png')" alt="好きなデザイン×4つのレイアウトで自分好みのシールを作れるよ ＼ロゴも自由に変えられるよ♡／">
            </div>
        </template>
        <template v-slot:content-5>
            <div class="cont-05">
                <div class="cont-05-bk">
                    <img class="img-01" :src="buildImgUrl('contents_05_01.gif')" alt="カラーチャートペン 画面イメージ">
                    <img class="img-02" :src="buildImgUrl('contents_05_02.png')" alt="好きなカラーで自由に落書きできる♡ ＼推し活やイベントにぴったり！／">
                </div>
            </div>
        </template>
        <template v-slot:content-6>
            <div class="cont-06">
                <img class="img-01" :src="buildImgUrl('contents_06_01.png')" alt="韓国で大人気！MUZIK TIGERコラボシールがハルセカ3に登場！期間限定！シールデザイン搭載中 2025年8月31日(日)まで">
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "MachineHaruirosekai3",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            machineId: 163,
        }
    },
    computed: {
        ...mapGetters('AccountStoreV2', [
            'accountStatus'
        ]),
        sectionTitleList() {
            const isEndCollaboration = this.accountStatus && this.accountStatus.timeTripDate
                && this.accountStatus.timeTripDate.isAfterTime("2025-09-01T00:00:00")

            const titleList = [
                '01 ハルセカ史上透明感MAXな写り',
                '02 選べる2つの写りテイスト',
                '03 新登場！ハルセカパレット',
                '04 満足感UP♡ クリアシール',
                '05 NEW!カラーチャートペン'
            ]
            if(!isEndCollaboration) {
                titleList.push('06 MUZIK TIGER コラボ！')
            }

            return titleList
        }
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(350px, $deviceWidth));
                left: 0;
                width: 100%;

                &-link {
                    width: math.percentage(math.div(460px, $deviceWidth));
                }
            }

            .list-anchor-link {
                padding: (variables.$grid-base) 0 0 0;
            }
        }

        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07, {
                    display: block;
                }

                .cont-03 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('contents_03_bk.png')");
                        background-size: cover;
                    }
                }
                .cont-05 {
                    &-bk {
                        position: relative;
                        background: v-bind("buildStyleImgUrl('contents_05_bk.png')");
                        background-size: cover;
                        .img-01 {
                            position: absolute;
                            top: math.percentage(math.div(56px, $deviceWidth));
                        }
                    }
                }
            }
        }

        &-movie {
            padding: variables.$grid-consistent * 20.5 0 variables.$grid-consistent * 15.25;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            border-top: 1px solid variables.$color-pictlink-black-20;
            border-bottom: 1px solid variables.$color-pictlink-black-20;
        }
    }
}

</style>
